export default "__VITE_ASSET__4WrZ8AQk__"